import BottomNavigation from "components/BottomNavigation"
import { SaveButton } from "components/Buttons"
import { SwitchInputField } from "components/RenderInput"
import UnsavedAlertModal from "components/UnsavedAlertModal"
import { FORM_NAMES } from "constants/index"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Card, CardBody, CardHeader, Col, Modal, Row } from "reactstrap"
import { Field, FieldArray, isDirty, reset } from "redux-form"
import {
  hideSelectUsersModal,
  openSelectUsersModal,
  updateContactData,
  updateContactUsSetup,
} from "store/actions"
import PhonePreview from "./phonePreview"
import SelectUsersModal from "./selectUsersModal"
import ContactList from "./contactList"

const AddContactsTab = ({
  openSelectUsersModal,
  hideSelectUsersModal,
  selectUsersModalIsOpen,
  updateContactUsSetup,
  contactUsSetup,
  updateContactData,
  handleBack,
  isDirty,
  resetForm,
  handleSave,
  tabIsActive,
}) => {
  const [showAlertModal, setShowAlertModal] = useState(false)

  useEffect(() => {
    if (!tabIsActive && isDirty) {
      setShowAlertModal(true)
    }
  }, [tabIsActive])

  const addContactHandler = user => {
    const newUserList = [...contactUsSetup?.users, ...user]
    updateContactUsSetup({
      values: {
        ...contactUsSetup,
        users: newUserList,
        user_ids: newUserList.map(user => user.id),
      },
    })
    hideSelectUsersModal()
  }

  const removeContactHandler = id => {
    const newUserList = contactUsSetup?.users?.filter(user => user.id !== id)
    updateContactUsSetup({
      values: {
        ...contactUsSetup,
        users: newUserList,
        user_ids: newUserList.map(user => user.id),
      },
    })
  }

  const updateContactHandler = contact => {
    updateContactData({ values: contact })
  }

  return (
    <React.Fragment>
      <Row className="mt-3">
        <Col xl={8}>
          <Card>
            <CardHeader>
              <h4>Add Contacts</h4>
            </CardHeader>
            <CardBody>
              <Row>
                <Col xs="auto" className="mt-3">
                  <label>Remove Search: </label>
                </Col>
                <Col>
                  <Field
                    name="removeSearch"
                    component={SwitchInputField}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    onColor="#2ECC71"
                    offColor="#E74C3C"
                    height={20}
                    width={40}
                    handleDiameter={18}
                  />
                </Col>
              </Row>
              <Row className="my-3">
                <p>
                  Select users which will be visible on the contact list - in
                  app
                </p>
              </Row>
              <Row>
                <Col xs="auto">
                  <SaveButton
                    type="button"
                    content="Select Users"
                    onClick={openSelectUsersModal}
                  />
                </Col>
                {contactUsSetup?.users?.length > 0 && (
                  <Col xs="auto">
                    <SaveButton
                      type="button"
                      content="Clear All"
                      color="danger"
                      onClick={() => {
                        updateContactUsSetup({
                          values: {
                            ...contactUsSetup,
                            users: [],
                            user_ids: [],
                          },
                        })
                      }}
                    />
                  </Col>
                )}
              </Row>
              <Row>
                <Col>
                  {contactUsSetup?.users && (
                    <FieldArray
                      name="contacts"
                      component={ContactList}
                      removeContactHandler={removeContactHandler}
                      updateContactHandler={updateContactHandler}
                      updateContactData={updateContactData}
                    />
                  )}
                </Col>
              </Row>
            </CardBody>
          </Card>
          <BottomNavigation handleBack={handleBack} handleSave={handleSave} />
        </Col>
        <Col xl={4} className="mt-4 d-none d-xl-block">
          <PhonePreview />
        </Col>
      </Row>
      <Modal
        isOpen={selectUsersModalIsOpen}
        toggle={hideSelectUsersModal}
        scrollable={true}
        centered={true}
        size="lg"
      >
        <SelectUsersModal
          addUserHandler={addContactHandler}
          addedUsers={contactUsSetup?.users?.map(user => user?.id)}
        />
      </Modal>
      <UnsavedAlertModal
        isOpen={showAlertModal}
        onClose={() => {
          setShowAlertModal(false)
          resetForm()
        }}
        onSave={() => {
          handleSave()
          setShowAlertModal(false)
        }}
      />
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  selectUsersModalIsOpen: state.ContactUsScreen.selectUsersModalIsOpen,
  contactUsSetup: state.ContactUsScreen.contactUsSetup,
  isDirty: isDirty(FORM_NAMES.CONTACT_US)(
    state,
    ...["add_contacts.removeSearch"]
  ),
})

const mapDispatchToProps = dispatch => ({
  openSelectUsersModal: () => dispatch(openSelectUsersModal()),
  hideSelectUsersModal: () => dispatch(hideSelectUsersModal()),
  updateContactUsSetup: values => dispatch(updateContactUsSetup(values)),
  updateContactData: values => dispatch(updateContactData(values)),
  resetForm: () => dispatch(reset(FORM_NAMES.CONTACT_US)),
})

export default connect(mapStateToProps, mapDispatchToProps)(AddContactsTab)
